import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=533f7f22&scoped=true"
import script from "./breadCrumb.vue?vue&type=script&lang=js"
export * from "./breadCrumb.vue?vue&type=script&lang=js"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=533f7f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f7f22",
  null
  
)

export default component.exports